<template>
  <li class="section">
    <fieldset>
      <ol class="questions">
        <legend>
          <span class="h3">Relationship</span>
        </legend>
        <legend>
          <span id="related-label" class="label"
            >Are the parties related to each other?</span
          >
        </legend>

        <ul class="choices compact">
          <li>
            <input
              class=""
              type="radio"
              id="related.yes"
              value="true"
              name="Parties Related"
              v-model="relationshipDetails.partiesRelated"
            />
            <label for="related.yes">Yes</label>
          </li>
          <li>
            <input
              class=""
              type="radio"
              id="related.no"
              value="false"
              name="Parties Related?"
              v-model="relationshipDetails.partiesRelated"
            />
            <label for="related.no">No</label>
          </li>
        </ul>

        <li v-if="relationshipDetails.partiesRelated === 'true'">
          <label
            id="relationship-label"
            for="relationship"
          >
            <span class="label">Please state the type of relationship</span>
          </label>

          <input
            autocomplete="off"
            class="titleCaseOnFirstBlur"
            id="relationship"
            type="text"
            size="30"
            name="Relationship Type"
            maxlength="255"
            role="presentation"
            v-model="relationshipDetails.relationship"
          />
        </li>
      </ol>
    </fieldset>
  </li>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    value: Object,
  },
  computed: {
    relationshipDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>